<template>
    <b-row class="gx-0 mb-2">
        <b-col class="dd">
            <label class="mb-3" for="input-measureable"><strong>{{ $translate('assets') }}</strong></label>
            <multiselect id="input-measureable" :deselectLabel="deselectLabel" :selectedLabel="selectedLabel" :selectLabel="selectLabel" open-direction="bottom"  :disabled="disabled" :placeholder="$translate('none_selected')" v-model="selectedAssets"
                :multiple="true" :close-on-select="false" :options="parseAssets(customerAssets)" label="text" track-by="value">
            </multiselect>
        </b-col>
    </b-row>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    name: 'ViewAssets',
    props: ['value', 'customer_id', 'customerAssets', 'disabled'],
    components: { Multiselect },
    data() {
        return {
            selectedAssets: [],
        }
    },

    computed: {
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },

    },

    watch: {
        selectedAssets: {
            handler: function (val) {
                this.$emit(
                    'input',
                    val.map(x => x.value)
                )
            },
        },
    },

    mounted() {
        const { value, customerAssets } = this
        const assetValue = value.map(id =>
            customerAssets.find(asset => asset.id == id)
        )
        this.selectedAssets = this.parseAssets(assetValue)
    },

    methods: {
        parseAssets(assets) {
            return assets.map(x => ({
                value: x.id,
                text: `${x.name}${x.serial_no ? '-' + x.serial_no : ''}`,
            }))
        },
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
